import React from 'react';
import { Table, OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ProjectsTable = ({
    onEdit,
    onView,
    onViewHistory,
    onDelete,
    onContactClick
}) => {
    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th>Project Name</th>
                    <th width="180px" className='text-center'>Budget</th>
                    <th width="100px" className='text-center'>Client</th>
                    <th width="100px" className='text-center'>Sales</th>
                    <th width="100px" className='text-center text-nowrap'>PM</th>
                    <th width="100px" className='text-center text-nowrap'>Team</th>
                    <th width="180px" className='text-center'>Timeline Progress</th>
                    {/* <th width="80px" className='text-center'>Payment</th> */}
                    <th width="80px" className='text-center'>Status</th>
                    <th width="80px" className='text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[...Array(10)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <div className='c-avatar c-avatar-text'>
                                        E
                                    </div>
                                    <div>
                                        <div className='p-tag fw-bold'><Link to={`/projects/details`} className='text-black text-decoration-none primary-link'>eCommerce Website</Link></div>
                                        <div className='p-tag fs-12'>Netclues Technologies</div>
                                        <div className='p-tag fs-12'>Date: 01/01/2023 to 01/31/2023</div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex flex-column align-items-start">
                                    <div className="p-tag fw-bold fs-12 mb-1">$24k (10%)</div>
                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                        <div>$250k total</div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>John Doe</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            JD
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>+3 Members</Tooltip>}
                                    >
                                        <div className='c-avatar c-avatar-text c-avatar-sm me-0' onClick={onContactClick}>
                                            +3
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex flex-column align-items-start">
                                    <div className="p-tag fw-bold fs-12 mb-1">239h 0m (40%)</div>
                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                        <div>250 Tasks</div>
                                        <div>118 Tasks Left</div>
                                    </div>
                                </div>
                            </td>
                            {/* <td className='text-center'>
                                <Dropdown className='c-dropdown-2'>
                                    <Dropdown.Toggle variant="btn" id="dropdown-basic">
                                        No Status
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <button className="dropdown-item" onClick={onDelete}>No Status</button>
                                        <button className="dropdown-item" onClick={onDelete}>Pending</button>
                                        <button className="dropdown-item" onClick={onDelete}>Partially Paid</button>
                                        <button className="dropdown-item" onClick={onDelete}>Paid</button>
                                        <button className="dropdown-item" onClick={onDelete}>Overdue</button>
                                        <button className="dropdown-item" onClick={onDelete}>Cancelled</button>
                                        <button className="dropdown-item" onClick={onDelete}>Refunded</button>
                                        <button className="dropdown-item" onClick={onDelete}>Failed</button>
                                        <button className="dropdown-item" onClick={onDelete}>In Progress</button>
                                        <button className="dropdown-item" onClick={onDelete}>On Hold</button>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td> */}
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-2'>
                                    <Dropdown.Toggle variant="btn" id="dropdown-basic">
                                        No Status
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <button className="dropdown-item" onClick={onDelete}>No Status</button>
                                        <button className="dropdown-item" onClick={onDelete}>New Project</button>
                                        <button className="dropdown-item" onClick={onDelete}>In Discussion</button>
                                        <button className="dropdown-item" onClick={onDelete}>Cancelled</button>
                                        <button className="dropdown-item" onClick={onDelete}>Layout in Process</button>
                                        <button className="dropdown-item" onClick={onDelete}>Layout Submitted</button>
                                        <button className="dropdown-item" onClick={onDelete}>Layout Approved</button>
                                        <button className="dropdown-item" onClick={onDelete}>Awaiting Dev. Team</button>
                                        <button className="dropdown-item" onClick={onDelete}>In Progress</button>
                                        <button className="dropdown-item" onClick={onDelete}>Project Delayed</button>
                                        <button className="dropdown-item" onClick={onDelete}>on Hold</button>
                                        <button className="dropdown-item" onClick={onDelete}>Completed</button>
                                        <button className="dropdown-item" onClick={onDelete}>Go Live</button>
                                        <button className="dropdown-item" onClick={onDelete}>Termination</button>
                                        <button className="dropdown-item" onClick={onDelete}>Bad Debt</button>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item as={Link} to={`/projects/details/`}><i className="fas fa-eye me-2"></i> View</Dropdown.Item>
                                        <Dropdown.Item onClick={onViewHistory}><i className="fas fa-history me-2"></i> View History</Dropdown.Item>
                                        <Dropdown.Item onClick={onDelete} className="text-danger"><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default ProjectsTable;
